<template>
    <div class="invoicePay" v-if="opened">
        <div class="med-middle__container invoicePay__container">
            <div class="invoicePay__body">
                <div class="invoicePay__close-btn"
                     @click="closePopup"></div>
                <div class="invoicePay__body-title" v-if="currentStep === 1 || currentStep === 2">
                    Оплата счета
                </div>
                <div class="invoicePay__notFound" v-if="currentStep === 'notFound'">
                    Такого счета не существует.<br>Пожалуйста, проверьте правильность ввода.
                    <div class="invoicePay__notFound-btn" @click="currentStep = 1">Назад</div>
                </div>
                <div class="invoicePay__payment" v-if="currentStep === 'payment'">
                    Ваш счет уже оплачен.
                </div>
                <div
                    class="invoicePay__type-description"
                    v-if="currentStep === 1"
                >
                    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M22 2.5H2L2 5.87498H22V2.5ZM2 15.5L2 7.87498H22V15.5H2ZM2 0.5C0.895431 0.5 0 1.39543 0 2.5V15.5C0 16.6046 0.89543 17.5 2 17.5H22C23.1046 17.5 24 16.6046 24 15.5V2.5C24 1.39543 23.1046 0.5 22 0.5H2ZM5.45459 11.1875C4.90231 11.1875 4.45459 11.6352 4.45459 12.1875C4.45459 12.7398 4.90231 13.1875 5.45459 13.1875H8.13058C8.68286 13.1875 9.13058 12.7398 9.13058 12.1875C9.13058 11.6352 8.68286 11.1875 8.13058 11.1875H5.45459Z" fill="#00ABAA"/>
                    </svg>
                    <div class="np-form__type-description-text">
                        Оплата банковской картой
                    </div>
                </div>
                <InvoicePayFirstStep
                    v-if="currentStep === 1"
                    @goToNotFound="currentStep = 'notFound'"
                    @goToPayment="currentStep = 'payment'"
                    @goToSecond="goToSecondStep"
                />
                <InvoicePaySecondStep
                    v-if="currentStep === 2"
                    @goToFirst="currentStep = 1"
                    :formData="formData"
                />
            </div>
        </div>
        <Overlay
            :on="opened"
            @closePopup="closePopup"
        />
    </div>
</template>
<script>
import Overlay from "@/components/PopupOverlay";
import InvoicePayFirstStep from "@/components/invoicePay/InvoicePayFirstStep";
import InvoicePaySecondStep from "@/components/invoicePay/InvoicePaySecondStep";

export default {
    components: {
        InvoicePayFirstStep,
        InvoicePaySecondStep,
        Overlay
    },
    data() {
        return {
            opened: false,
            currentStep: 1,
            formData: null
        }
    },
    methods: {
        pageScroll(value) {
            !value ?
                document.querySelector('body').classList.add('__no-scroll') :
                document.querySelector('body').classList.remove('__no-scroll');
        },
        closePopup() {
            this.opened = false;
        },
        openInvInside(e) {
            if (e.target.classList.contains('vue-open-invoice-pay')) {
                this.opened = true;
                this.currentStep = 1;
            }
        },
        goToSecondStep(data) {
            this.currentStep = 2;
            this.formData = data;
        }
    },
    watch: {
        opened: function() {
            this.pageScroll(!this.opened); // убираем скролл страницы, если попап открыт
        },
    },
    created() {
        this.pageScroll(!this.opened);
    },
    mounted() {
        const self = this;

        document.addEventListener('click', function(e) {
            self.openInvInside(e)
        })
    }
}
</script>

<style lang="scss">
@import '../../assets/scss/mixins-and-vars';

$p: '.invoicePay';

#{$p} {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    color: #333;
    font-family: 'HelveticaNeueCyr', 'Helvetica Neue', Arial, sans-serif;
    z-index: 1000;

    &__body {
        display: flex;
        flex-direction: column;
        position: absolute;
        max-width: 600px;
        max-height: calc(100% - 30px);
        width: calc(100% - 30px);
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 48px;
        background: #fff;
        border-radius: 20px;
        z-index: 3;
        animation: easeOpen .15s ease-in-out;
        overflow: auto;
        overscroll-behavior: none;

        @include mobile {
            padding: 20px;
        }

        &-title {
            position: relative;
            font-weight: 700;
            font-size: 24px;
        }
    }

    &__type-description {
        display: flex;
        align-items: center;
        padding: 16px 24px;
        margin-top: 15px;
        border-radius: 16px;
        background: #FAF9F8;

        &.__form-steps {
            margin-bottom: 24px;
        }

        &.__last-step {
            margin-top: 15px;
            margin-bottom: 15px;
        }

        &-text {
            margin-left: 10px;
            font-weight: 400;
            font-size: 14px;
        }
    }

    &__notFound {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 40px 0 20px;

        &-btn {
            margin-top: 40px;
            border-radius: 7px;
            background: #fff;
            border: 1px solid #0AAEB3;
            padding: 10px 40px;
            color: #0AAEB3
        }
    }

    &__payment {
        padding: 60px 0 55px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-weight: 700;
        font-size: 24px;
    }

    &__close-btn {
        position: absolute;
        right: 48px;
        top: 56px;
        transform: translateY(-50%);
        height: 19px;
        width: 19px;
        cursor: pointer;
        background: #fff;
        z-index: 2;

        @include mobile {
            right: 20px;
            top: 39px;
        }

        &::before,
        &::after {
            position: absolute;
            display: block;
            content: '';
            top: 50%;
            left: 50%;
            width: 26px;
            height: 1px;
            background: #6c6c6c;

            @include mobile {
                width: 20px;
            }
        }

        &::after {
            transform: translate(-50%, -50%) rotate(45deg);
        }
        &::before {
            transform: translate(-50%, -50%) rotate(-45deg);
        }
    }
}

</style>